<div [class]="'container alert-' + data.state">
  <span class="icon">
    <mat-icon class="material-symbols-outlined"> {{ alertIcons[data.state] }} </mat-icon>
  </span>
  <div class="content">
    <span class="alert-title">{{ data.title }}</span>
    <span class="alert-description" *ngIf="data?.description">{{ data.description ?? '' }}</span>
  </div>
  <span class="snackbar-actions">
    <button mat-button color="primary" *ngIf="data?.secondaryAction" (click)="data.secondaryAction?.action()">
      {{ data.secondaryAction?.label ?? '' }}
    </button>
    <button mat-icon-button (click)="close$.next()" *ngIf="closeable">
      <mat-icon>close</mat-icon>
      <!-- <span class="material-symbols-outlined">close</span> -->
    </button>
  </span>
</div>
